// extracted by mini-css-extract-plugin
export default {"productSelector":"FormCapture_productSelector__luiJR","expanded":"FormCapture_expanded__vW9NO"};